class EsaCustomSubscription extends HTMLElement {
  constructor() {
    super();
    this.selectedPlanInput = null;
  }
  connectedCallback() {
    if (this.__mounted) return;
    this.__mounted = true;
    this.cacheElements();
    this.bindPlanEvents();
    this.bindPageEvents();
    this.updateFromSelectedPlan();
  }
  cacheElements() {
    this.planInputs = this.querySelectorAll('input[name="esa_subscription_plan"]');
    this.subscriptionPrice = this.querySelector('.esa__sub-price');
    this.subscriptionComparePrice = this.querySelector('.esa__sub-compare-price');
    this.subscriptionSaveLabel = this.querySelector('.esa__sub-save-label');
    this.oneTimeButton = this.querySelector('.esa__product-form-ot button[type="submit"] span');
    this.subscriptionVariantInput = this.querySelector('#esa__variant-input-sub');
    this.subscriptionSellingPlanInput = this.querySelector('#esa__selling-plan-id');
    this.subscriptionQuantityInput = this.querySelector('#esa__qauntity-input');
    this.oneTimeVariantInput = this.querySelector('#esa__variant-input-ot');
    this.oneTimeQuantityInput = this.querySelector('#esa__qauntity-input-ot');
    this.planCards = this.querySelectorAll('.esa-subscription__plan');
  }

  bindPageEvents() {
    window.addEventListener('pageshow', () => {
      this.refreshWidget();
    });

    window.addEventListener('popstate', () => {
      this.refreshWidget();
    });
  }

  refreshWidget() {
    this.cacheElements();
    this.bindPlanEvents();
    this.updateFromSelectedPlan();
  }

  bindPlanEvents() {
    this.planInputs?.forEach((input) => {
        if (input.dataset.esaChangeBound === 'true') return;

        input.dataset.esaChangeBound = 'true';

        input.addEventListener('change', () => {
          this.updateFromSelectedPlan();
        });
    });
  }

  updateFromSelectedPlan() {
    const selectedInput = this.querySelector('input[name="esa_subscription_plan"]:checked');
    if(!selectedInput) return;
    this.selectedPlanInput = selectedInput;
    const {
      variantId,
      sellingPlanId,
      qty,
      price,
      oneTimePrice,
      subscriptionPrice,
      comparePrice,
      discount
    } = selectedInput.dataset;
    
    if(this.subscriptionPrice) {
      this.subscriptionPrice.textContent = subscriptionPrice  || '';
    }
    if(this.subscriptionComparePrice) {
      if(comparePrice && comparePrice !== price) {
        this.subscriptionComparePrice.textContent = comparePrice;
        this.subscriptionComparePrice.classList.remove('hidden');
      } else {
        this.subscriptionComparePrice.textContent = '';
        this.subscriptionComparePrice.classList.add('hidden');
      }
    }
    if(this.subscriptionSaveLabel) {
      if(discount) {
        this.subscriptionSaveLabel.textContent = discount;
        this.subscriptionSaveLabel.classList.remove('hidden');
      } else {
        this.subscriptionSaveLabel.textContent = '';
        this.subscriptionSaveLabel.classList.add('hidden');
      }
    }
    
    const oneTimeText = this.dataset.oneTimeText || '';
    if(this.oneTimeButton) {
      this.oneTimeButton.textContent = oneTimeText.replace('[price]', oneTimePrice || '');
    }
    
    if(this.subscriptionVariantInput) {
      this.subscriptionVariantInput.value = variantId || '';
      this.subscriptionVariantInput.disabled = !variantId;
    }
    if(this.subscriptionSellingPlanInput) {
      this.subscriptionSellingPlanInput.value = sellingPlanId || '';
    }
    if(this.subscriptionQuantityInput) {
      this.subscriptionQuantityInput.value = qty || 1;
    }
    
    if(this.oneTimeVariantInput) {
      this.oneTimeVariantInput.value = variantId || '';
      this.oneTimeVariantInput.disabled = !variantId;
    }
    if(this.oneTimeQuantityInput) {
      this.oneTimeQuantityInput.value = qty || 1;
    }

    this.planCards.forEach((card) => {
      card.classList.remove('is-selected');
    });
    const selectedCard = selectedInput.closest('.esa-subscription__plan');
    if(selectedCard) {
      selectedCard.classList.add('is-selected');
    }
  }
}
customElements.define('esa-custom-subscription', EsaCustomSubscription);